import { useCallback, useEffect, useState } from 'react';
import { LicenseSelfServeRenewal } from '../stores/types/licenses.interface';

export function useLicenseRenewalResultFromStorage() {
  const [renewalId, setRenewalId] = useState<string | null>(null);
  const [licenses, setLicenses] = useState<LicenseSelfServeRenewal[]>([]);

  useEffect(() => {
    setRenewalId(sessionStorage.getItem('renewalId'));
    const licensesStr = sessionStorage.getItem('renewalLicenses');
    setLicenses(licensesStr ? JSON.parse(licensesStr) : []);
  }, []);

  const storeRenewalResult = useCallback((id: string, renewals: LicenseSelfServeRenewal[]) => {
    sessionStorage.setItem('renewalId', id);
    sessionStorage.setItem('renewalLicenses', JSON.stringify(renewals));
    setRenewalId(id);
    setLicenses(renewals);
  }, []);

  return { renewalId, licenses, storeRenewalResult };
}
